/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'power-on-off': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M15.161 4.031a7.867 7.867 0 012.352 8.77C16.359 15.923 13.358 18 10 18c-3.358 0-6.36-2.077-7.513-5.199a7.867 7.867 0 012.352-8.77.579.579 0 01.81.068c.205.24.174.599-.068.801a6.737 6.737 0 00-2.014 7.51c.988 2.674 3.557 4.452 6.433 4.452s5.445-1.778 6.433-4.452A6.737 6.737 0 0014.42 4.9a.565.565 0 01-.068-.801.579.579 0 01.81-.068zM10.002 2c.284 0 .52.201.568.467l.01.102v7.587a.573.573 0 01-.578.569.575.575 0 01-.568-.467l-.009-.102V2.569c0-.314.259-.569.577-.569z"/>'
  }
})
